<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import PrintPO from "@/components/ipos/print-po";
import appConfig from "@/app.config";
import { orderService } from "@/services/authservice/order";
import { commonService } from "@/services/common";
import UtilsMixin from "@/mixins/utils";
import Multiselect from "vue-multiselect";
import { accountService } from "@/services/authservice/account";
import DatePicker from "vue2-datepicker";
import { itemService } from "@/services/authservice/item";
import PrintCombineItem from "@/components/ipos/print-combine-item";
import { brandService } from "@/services/authservice/brand";
import PrintExportShipper from "@/components/ipos/print-export-shipper";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import PagingMixin from "../../../mixins/paging";
import { customerService } from "@/services/authservice/customer";
import PrintOrder
  from "@/components/ipos/print-order";

export default {
  page: {
    title: "Danh sách đơn hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin, PagingMixin],
  components: {
    PrintOrder,
    PrintExportShipper,
    PrintCombineItem,
    Layout,
    PageHeader,
    TableLoading,
    TableEmpty,
    PrintPO,
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      listData: [],
      listRegion: [],
      listBrand: [],
      title: "Danh sách đơn hàng",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Danh sách đơn hàng",
          active: true,
        },
      ],
      fields: [
        { key: "checkbox", label: "Check" },
        { key: "po_id", label: "Mã đơn" },
        { key: "customer_name", label: "Khách hàng" },
        { key: "customer_store", label: "Điểm đặt hàng", class: "td-mw-300" },
        { key: "note", label: "Ghi chú đặt đơn", class: "td-mw-200" },
        { key: "stocker_note", label: "Ghi chú thủ kho", class: "td-mw-200" },
        { key: "status", label: "Trạng thái" },
        { key: "created_by", label: "Người tạo" },
        { key: "require_time", label: "Thời gian giao" },
        { key: "print_count", label: "Số lần in" },
      ],
      isBusy: false,
      me: {},
      selectedOrder: [],
      printObj: {
        id: "poPrint",
      },
      selectedPrintPO: [],
      dataPrintPO: [],
      isLoadingDataPrint: false,
      selectedPrintCombineItem: [],
      selectedPrintCombineItemTotal:0,
      isSelectedAll: false,
      listShipper: [],
      listAgency: [],
      listSalesman: [],
      listAcctountant: [],
      listTelesale: [],
      listCustomerStore: [],
      listCustomer: [],
      searchData: {
        id: "",
        name: "",
        shipper: "",
        salesman: "",
        date: [],
        brand: "",
        customerStore: "",
        customer: "",
        status: { id: "CONFIRMED", name: "Đã xác nhận" },
        page: 1,
        saleChannel: "",
      },
      formData: {
        shipper: "",
      },
      listStatus: [
        { id: "PENDING", name: "Chờ xác nhận" },
        { id: "CONFIRMED", name: "Đã xác nhận" },
        { id: "SHIPPING", name: "Đang giao hàng" },
        { id: "COMPLETED", name: "Đã hoàn thành" },
        { id: "EXPORTED", name: "Đã xuất kho" },
        { id: "NOT_COMPLETED", name: "Giao hàng thất bại" },
        { id: "CANCELED", name: "Đã huỷ" },
      ],
      listSaleChannel: [
        { id: "", name: "Tất cả" },
        { id: "AGENCY", name: "Đơn từ đại lý" },
        { id: "SALESMAN", name: "Đơn từ salesman" },
        { id: "TELESALES", name: "Đơn từ telesales" },
        { id: "DEBT_ACCOUNTANT", name: "Đơn từ kế toán" },
        { id: "APP_CUSTOMER", name: "Đơn từ App khách hàng" },
      ],
      distributorInfo: {},
      isLoadingPrint: false,
      isLoadingCombine: false,
      poHasItem: [],
      itemEditQuantity: "",
      totalQuantityItem: 0,
      isLoadingChangeStatusAndPrint: false,
      isLoadingPrintExport: false,
      dataPrintExport: {},
      newDetailEdit: {},
      isValidQuantity: true,
      statusPOCombile: "",
    };
  },

  methods: {
    async getInitData() {
      const regionPromise = commonService.getListRegion();
      const shipperPromise = accountService.getList({ role_id: "SHIPPER" });
      const salesmanPromise = accountService.getList({ role_id: "SALESMAN" });
      const telesalePromise = accountService.getList({ role_id: "TELESALES" });
      const agencyPromise = accountService.getList({ role_id: "AGENCY" });
      const accountantPromise = accountService.getList({
        role_id: "DEBT_ACCOUNTANT",
      });
      const brandPromise = brandService.getList();
      const customerStorePromise = customerService.getListCustomerStore();
      const customerPromise = customerService.getListCustomer({
        results_per_page: 2000,
      });
      // get list region
      const responseRegion = await regionPromise;
      responseRegion.data.error
        ? (this.listRegion = [])
        : (this.listRegion = responseRegion.data.data);
      // get list shipper
      const resShipper = await shipperPromise;
      resShipper.data.error
        ? (this.listShipper = [])
        : (this.listShipper = resShipper.data.data);
      // get list salesman
      const resSalesman = await salesmanPromise;
      resSalesman.data.error
        ? (this.listSalesman = [])
        : (this.listSalesman = resSalesman.data.data);
      // get list telesale
      const resTelesale = await telesalePromise;
      resTelesale.data.error
        ? (this.listTelesale = [])
        : (this.listTelesale = resTelesale.data.data);
      // get list telesale
      const resAgency = await agencyPromise;
      resAgency.data.error
        ? (this.listAgency = [])
        : (this.listAgency = resAgency.data.data);
      // get list acctountant
      const resAcctountant = await accountantPromise;
      resAcctountant.data.error
        ? (this.listAcctountant = [])
        : (this.listAcctountant = resAcctountant.data.data);
      // get list brand
      const resBrand = await brandPromise;
      resBrand.data.error
        ? (this.listBrand = [])
        : (this.listBrand = resBrand.data.data);
      // get list customer store
      const resCustomerStore = await customerStorePromise;
      resCustomerStore.data.error
        ? (this.listCustomerStore = [])
        : (this.listCustomerStore = resCustomerStore.data.data);
      // get list customer
      const resCustomer = await customerPromise;
      resCustomer.data.error
        ? (this.listCustomer = [])
        : (this.listCustomer = resCustomer.data.data.map((e) => {
            return {
              id: e.id,
              customer_id: e.customer_id,
              customer_name: e.customer_name,
              customer_email: e.customer_email,
              customer_address: e.customer_address,
              customer_phone: e.customer_phone,
            };
          }));
    },

    async getDataDefault() {
      this.currentPage = 1;
      this.totalResult = 0;
      this.totalPage = 1;
      this.perPage = 10;
      let date = new Date();
      const firstDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        1,
        0,
        0,
        0
      );
      const lastDay = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0,
        23,
        59,
        59,
        999
      );
      this.searchData = {
        date: [firstDay, lastDay],
        id: "",
        name: "",
        shipper: "",
        salesman: "",
        status: { id: "CONFIRMED", name: "Đã xác nhận" },
        brand: "",
        customerStore: "",
        customer: "",
        page: 1,
        saleChannel: "",
      };
      let param = {
        from_timestamp: firstDay.getTime(),
        to_timestamp: lastDay.getTime(),
        shipper_type: "SHIPPER",
        list_po_type: "CUSTOMER,AGENCY",
        warehouse_uid: this.me["warehouse_uid"],
        status: "CONFIRMED",
        results_per_page: this.perPage,
      };

      const res = await orderService.getListOrder(param);
      if (res.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
        this.totalResult = res.data.num_results;
        this.totalPage = res.data.total_pages;
      }
    },

    async checkParameter() {
      if (this.$route.query.from_timestamp && this.$route.query.to_timestamp) {
        const firstDay = new Date(parseInt(this.$route.query.from_timestamp));
        const lastDay = new Date(parseInt(this.$route.query.to_timestamp));
        this.searchData.date = [firstDay, lastDay];
      }
      if (this.$route.query.po_id) {
        this.searchData.id = this.$route.query.po_id;
      }
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name;
      }
      if (this.$route.query.shipper) {
        this.searchData.shipper = this.listShipper.find(
          (e) => e.email === this.$route.query.shipper
        );
      }
      if (this.$route.query.created_by) {
        this.searchData.salesman = this.listSalesman.find(
          (e) => e.email === this.$route.query.created_by
        );
      }
      if (this.$route.query.status) {
        this.searchData.status = this.listStatus.find(
          (e) => e.id === this.$route.query.status
        );
      }
      if (this.$route.query.trademark_uid) {
        this.searchData.brand = this.listBrand.find(
          (e) => e.id === this.$route.query.trademark_uid
        );
      }
      if (this.$route.query.customer_store_uid) {
        this.searchData.customerStore = this.listCustomerStore.find(
          (e) => e.id === this.$route.query.customer_store_uid
        );
      }
      if (this.$route.query.customer_uid) {
        this.searchData.customer = this.listCustomer.find(
          (e) => e.id === this.$route.query.customer_uid
        );
      }
      if (this.$route.query.page) {
        this.searchData.brand = this.listBrand.find(
          (e) => e.id === this.$route.query.trademark_uid
        );
      }
      if (this.$route.query.sale_channel_id) {
        this.searchData.saleChannel = this.listSaleChannel.find(
          (e) => e.id === this.$route.query.sale_channel_id
        );
      }
      await this.getDataTable();
    },

    async getDataTable() {
      let param = {
        shipper_type: "SHIPPER",
        list_po_type: "CUSTOMER,AGENCY",
        warehouse_uid: this.me["warehouse_uid"],
        from_timestamp: this.searchData.date[0]
          ? this.searchData.date[0].getTime()
          : null,
        to_timestamp: this.searchData.date[1]
          ? this.searchData.date[1].getTime()
          : null,
        po_id: this.searchData.id.trim() !== "" ? this.searchData.id : "",
        // customer_name: this.searchData.name ? this.searchData.name : "",
        shipper_id: this.searchData.shipper
          ? this.searchData.shipper.email
          : "",
        // created_by: this.searchData.salesman
        //   ? this.searchData.salesman.email
        //   : "",
        status: this.searchData.status ? this.searchData.status.id : "",
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : "",
        customer_store_uid: this.searchData.customerStore
          ? this.searchData.customerStore.id
          : "",
        customer_uid: this.searchData.customer
          ? this.searchData.customer.id
          : "",
        results_per_page: this.perPage,
        page: this.currentPage,
        sale_channel_id:
          this.searchData.saleChannel &&
          this.searchData.saleChannel.id !== "ALL"
            ? this.searchData.saleChannel.id
            : "",
      };

      param.customer_name = this.searchData.name ? this.searchData.name : "";
      param.created_by = this.searchData.salesman
        ? this.searchData.salesman.email
        : "";

      const res = await orderService.getListOrder(param);
      if (res.data.error) {
        this.listData = [];
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: res.data.error.message,
        });
      } else {
        this.listData = res.data.data;
        this.totalResult = res.data.num_results;
        this.totalPage = res.data.total_pages;
      }
    },

    renderRegion(id) {
      const find = this.listRegion.find((e) => e.id === id);
      return find ? find.region_name : "-";
    },

    onSelectOrder(id) {
      this.selectedPrintPO = this.listData.filter((e) => id.includes(e.id));
    },

    onSelectAll(value) {
      this.selectedOrder = [];
      this.selectedPrintPO = [];
      if (value) {
        this.selectedOrder = this.listData.map((e) => e.id);
        this.selectedPrintPO = this.listData;
      }
    },

    async onPrint(type) {
      if (this.selectedPrintPO.length > 0) {
        if (type === 'order') {
          this.isLoadingDataPrint = true
          const data = {
            list_uid: this.selectedOrder,
          };
          const res= await orderService.poPrint(data);
          if(res.data){
            this.dataPrintPO = res.data.data;
            setTimeout(()=>{
              this.$htmlToPaper("orderPrint", null, async () => {
                const body = {
                  list_uid: this.selectedOrder,
                };
                const response = await orderService.updatePrintPO(body);
                if (response.data.error) {
                  this.$notify({
                    group: "app",
                    type: "error",
                    title: "Đã có lỗi xảy ra",
                    text: response.data.error.message,
                  });
                }
              });
              this.isLoadingDataPrint = false
            }, 2000)
          }else{
            this.$notify({
              group: "app",
              type: "error",
              title: "Đã có lỗi xảy ra",
              text: res.data.error.message,
            });
            this.isLoadingDataPrint = false
          }
        } else {
          this.$htmlToPaper("poPrint", null, async () => {
            const body = {
              list_uid: this.selectedOrder,
            };
            const res = await orderService.updatePrintPO(body);
            if (res.data.error) {
              this.$notify({
                group: "app",
                type: "error",
                title: "Đã có lỗi xảy ra",
                text: res.data.error.message,
              });
            }
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn đơn để in",
        });
      }
    },

    onPrintExport() {
      if (
        this.selectedPrintPO.length > 0 &&
        this.searchData.date.length > 0 &&
        this.searchData.shipper
      ) {
        this.isLoadingPrintExport = true;
        let start = this.searchData.date[0].setHours(0, 0, 0, 0);
        let end = this.searchData.date[1].setHours(23, 59, 59, 999);
        this.distributorInfo = this.selectedPrintPO[0].distributor;
        this.dataPrintExport.shipper = this.searchData.shipper.name;
        this.dataPrintExport.date = [start, end];
        let total = 0;
        this.dataPrintExport.details = this.selectedPrintPO.map((e) => {
          total += e.final_amount;
          return {
            require_time: e.require_time,
            po_id: e.po_id,
            customer_store: e.customer_store
              ? e.customer_store.store_name
              : e.customer_name,
            store_contact_name: e.delivery_info
              ? e.delivery_info.contact_name
              : "-",
            store_address: e.delivery_info
              ? e.delivery_info.delivery_address
              : "-",
            final_amount: e.final_amount,
            created_user: e.created_user ? e.created_user.name : "-",
          };
        });
        this.dataPrintExport.final_amount = total;
        console.log(this.dataPrintExport);

        setTimeout(() => {
          this.$htmlToPaper("poPrintExport", null, async () => {});
          this.isLoadingPrintExport = false;
        }, 1000);
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title:
            "Vui lòng lọc đơn hàng theo khoảng thời gian và giao hàng. Sau đó chọn đơn hàng để in phiếu",
          duration: 5000,
        });
      }
    },

    onExport() {
      if (
        this.selectedPrintPO.length > 0 &&
        this.searchData.date.length > 0 &&
        this.searchData.shipper
      ) {
        this.isLoadingPrintExport = true;
        let start = this.searchData.date[0].setHours(0, 0, 0, 0);
        let end = this.searchData.date[1].setHours(23, 59, 59, 999);
        this.distributorInfo = this.selectedPrintPO[0].distributor;
        this.dataPrintExport.shipper = this.searchData.shipper.name;
        this.dataPrintExport.date = [start, end];
        this.dataPrintExport.details = this.selectedPrintPO.map((e) => {
          return {
            require_time: this.formatDate(e.require_time),
            po_id: e.po_id,
            customer_store: e.customer_store
              ? e.customer_store.store_name
              : e.customer_name,
            store_contact_name: e.delivery_info
              ? e.delivery_info.contact_name
              : "-",
            store_address: e.delivery_info
              ? e.delivery_info.delivery_address
              : "-",
            final_amount: e.final_amount,
            created_user: e.created_user ? e.created_user.name : "-",
          };
        });

        console.log(this.dataPrintExport);
        let workbook = new Workbook();
        let header = [
          { header: "Ngày xuất hàng", key: "require_time" },
          { header: "Mã đơn", key: "po_id" },
          { header: "Điểm đặt hàng", key: "customer_store" },
          { header: "Người nhận", key: "store_contact_name" },
          { header: "Địa chỉ giao hàng", key: "store_address" },
          { header: "Giá trị đơn hàng", key: "final_amount" },
          { header: "Người tạo đơn", key: "created_user" },
        ];

        const worksheet = workbook.addWorksheet("Danh sách đơn hàng");
        worksheet.properties.defaultColWidth = 30;
        worksheet.columns = header;

        this.dataPrintExport.details.forEach((d) => {
          worksheet.addRow(d);
        });
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          row.eachCell((cell) => {
            if (rowNumber === 1) {
              row.font = { bold: true };
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
              };
              for (let i = 1; i <= 7; i++) {
                row.getCell(i).fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "C7C7C7" },
                };
                row.getCell(i).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              }
            }
            cell.alignment = {
              wrapText: true,
            };
          });
        });

        // Generate Excel File with given name
        workbook.xlsx.writeBuffer().then((data) => {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fs.saveAs(blob, `EXPORT_PO_SHIPPER_${new Date().getTime()}.xlsx`);
        });
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title:
            "Vui lòng lọc đơn hàng theo khoảng thời gian và giao hàng. Sau đó chọn đơn hàng để in phiếu",
          duration: 5000,
        });
      }
    },

    async onSearch(page) {
      this.currentPage = page ? page : 1;
      let start = "";
      let end = "";
      if (
        this.searchData.date.length > 0 &&
        this.searchData.date[0] &&
        this.searchData.date[1]
      ) {
        start = this.searchData.date[0].setHours(0, 0, 0, 0);
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      }

      const paramShow = {
        from_timestamp: start,
        to_timestamp: end,
        po_id: this.searchData.id.trim() !== "" ? this.searchData.id : "",
        customer_name: this.searchData.name ? this.searchData.name : "",
        shipper: this.searchData.shipper ? this.searchData.shipper.email : "",
        created_by: this.searchData.salesman
          ? this.searchData.salesman.email
          : "",
        status: this.searchData.status ? this.searchData.status.id : "",
        sale_channel_id:
          this.searchData.saleChannel &&
          this.searchData.saleChannel.id !== "ALL"
            ? this.searchData.saleChannel.id
            : "",
        customer_uid: this.searchData.customer
          ? this.searchData.customer.id
          : "",
        trademark_uid: this.searchData.brand ? this.searchData.brand.id : "",
        customer_store_uid: this.searchData.customerStore
          ? this.searchData.customerStore.id
          : "",
        page: this.currentPage,
        ts: new Date().getTime(),
      };
      let strParam = "";
      for (let key in paramShow) {
        if (strParam !== "") {
          strParam += "&";
        }
        strParam += key + "=" + encodeURIComponent(paramShow[key]);
      }
      this.$router.push(`?${strParam}`, () => {
        console.log("Request seach...");
      });
    },

    async onResetSearch() {
      this.$router.push("/orders", () => {
        console.log("Reset default");
      });
    },

    hideModal() {
      this.formData.shipper = "";
      this.$bvModal.hide("md-confirm-ship");
    },

    async onCombineOrder() {
      if (this.selectedPrintPO.length > 0) {
        let checkStatus = this.selectedPrintPO[0].status;
        let isCanCombine = true;
        this.selectedPrintPO.forEach((e) => {
          if (e.status !== checkStatus) {
            isCanCombine = false;
          }
        });
        if (isCanCombine) {
          // chỉ tổng hợp đơn hàng có cùng trạng thái
          this.statusPOCombile = this.selectedPrintPO[0].status;
          this.isLoadingCombine = true;
          let arrDetailAll = [];
          this.selectedPrintPO.forEach((e) => {
            arrDetailAll = arrDetailAll.concat(e.details);
          });
          this.distributorInfo = this.selectedPrintPO[0].distributor;
          let details = arrDetailAll.map((e) => {
            return {
              ids_sku: e.ids_sku,
              cus_sku: e.cus_sku,
              item_name: e.item_name,
              unit_id: e.unit_id,
              unit_name: e.unit_name,
              request_qty: e.request_qty,
              export_qty: e.export_qty,
              delivery_qty: e.delivery_qty,
              revoke_qty: e.revoke_qty,
              return_qty: e.return_qty,
              return_amount: e.return_amount,
              price: e.price,
              price_org: e.price_org,
              vat: e.vat,
              amount: e.amount,
              amount_org: e.amount_org,
              amount_basis: e.amount_basis,
              amount_vat: e.amount_vat ? e.amount_vat : 0,
              discount_amount: e.discount_amount,
              discount_amount_org: e.discount_amount_org,
              note: e.note,
              promotion_id: e.promotion_id,
              promotion_name: e.promotion_name,
              include_inventory: true,
              trademark_uid: e.trademark_uid,
            };
          });
          const res = await itemService.combineOrderByItemInventory(details);
          if (res.data.data) {
            this.isLoadingCombine = false;
            this.$bvModal.show("md-show-combine");
            this.selectedPrintCombineItem = res.data.data;
          this.selectedPrintCombineItemTotal = res.data.data.reduce((n, {amount,amount_vat}) => n + amount + amount_vat, 0)
          } else {
            this.isLoadingCombine = false;
            this.$notify({
              group: "app",
              type: "error",
              title: "Đơn hàng có lỗi, vui lòng kiểm tra lại",
            });
          }
        } else {
          this.$notify({
            group: "app",
            type: "warn",
            text: "Vui lòng tổng hợp đơn hàng có cùng trạng thái",
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn đơn hàng",
        });
      }
    },

    onShowEditDetail(item) {
      this.itemEditQuantity = item;
      this.poHasItem = this.selectedPrintPO.filter((e) => {
        let arrItemSku = e.details.map((f) => f.ids_sku);
        return arrItemSku.indexOf(item.ids_sku) >= 0;
      });
      this.totalQuantityItem = this.totalQuantityExport();
      this.$bvModal.show("md-edit-quantity");
    },

    async onPrintCombine() {
      if (this.selectedPrintPO.length > 0) {
        this.isLoadingPrint = true;
        let arrDetailAll = [];
        this.selectedPrintPO.forEach((e) => {
          arrDetailAll = arrDetailAll.concat(e.details);
        });
        this.distributorInfo = this.selectedPrintPO[0].distributor;
        let details = arrDetailAll.map((e) => {
          return {
            ids_sku: e.ids_sku,
            cus_sku: e.cus_sku,
            item_name: e.item_name,
            unit_id: e.unit_id,
            unit_name: e.unit_name,
            request_qty: e.request_qty,
            export_qty: e.export_qty,
            delivery_qty: e.delivery_qty,
            revoke_qty: e.revoke_qty,
            return_qty: e.return_qty,
            return_amount: e.return_amount,
            price: e.price,
            price_org: e.price_org,
            vat: e.vat,
            amount: e.amount,
            amount_org: e.amount_org,
            amount_basis: e.amount_basis,
            discount_amount: e.discount_amount,
            discount_amount_org: e.discount_amount_org,
            note: e.note,
            promotion_id: e.promotion_id,
            promotion_name: e.promotion_name,
            trademark_uid: e.trademark_uid,
          };
        });
        const res = await itemService.combineOrderByItem(details);
        if (res.data.data) {
          this.selectedPrintCombineItem = res.data.data;
          setTimeout(() => {
            this.$htmlToPaper("combineByItemPrint", null, async () => {});
            this.isLoadingPrint = false;
          }, 1000);
        } else {
          this.isLoadingPrint = false;
          this.$notify({
            group: "app",
            type: "error",
            title: "Đơn hàng có lỗi, vui lòng kiểm tra lại",
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          title: "Vui lòng chọn đơn để in",
        });
      }
    },

    getQuantity(data, type) {
      if (this.itemEditQuantity !== "") {
        let item = data.find(
          (e) => e.ids_sku === this.itemEditQuantity.ids_sku
        );
        switch (type) {
          case "export":
            return item.export_qty;
          case "request":
            return item.request_qty;
          case "max":
            return item.max_edit_qty_allowed;
        }
      }
      return 0;
    },

    totalQuantityExport() {
      let total = 0;
      this.poHasItem.forEach((e) => {
        e.details.forEach((f) => {
          if (f.ids_sku === this.itemEditQuantity.ids_sku) {
            total = total + f.export_qty;
          }
        });
      });
      return total;
    },

    checkPoHasPromotion(po) {
      let itemCheck = po.details.find(
        (e) => e.ids_sku === this.itemEditQuantity.ids_sku
      );
      let check = true;
      if (itemCheck.max_edit_qty_allowed > 0 && !po.promotion_id) {
        check = false;
      }
      return check;
    },

    onChangeQuantity(value, po) {
      let newDetail = [];
      po.details.forEach((e) => {
        if (e.ids_sku === this.itemEditQuantity.ids_sku) {
          if (value !== "" && value) {
            // console.log(value);
            // console.log(e.request_qty);
            // console.log(e.max_edit_qty_allowed);
            if (
              parseFloat(value) <= e.request_qty &&
              parseFloat(value) >= e.request_qty - e.max_edit_qty_allowed
            ) {
              // nếu SL request - max_allow <= SL sửa <= SL request thì hợp lệ
              this.isValidQuantity = true;
              newDetail.push({
                ...e,
                export_qty: parseFloat(value),
                delivery_qty: parseFloat(value),
              });
            } else {
              this.isValidQuantity = false;
              newDetail.push({
                ...e,
                export_qty: e.request_qty,
                delivery_qty: e.request_qty,
              });
              this.$notify({
                group: "app",
                type: "error",
                duration: 5000,
                text: `Để không ảnh hướng đến CTKM đã áp dụng, số lượng phải lớn hơn ${
                  e.request_qty - e.max_edit_qty_allowed
                } và nhỏ hơn ${e.request_qty}`,
              });
            }
          } else {
            newDetail.push(e);
          }
        } else {
          newDetail.push(e);
        }
      });
      this.newDetailEdit = { ...po, details: newDetail };
    },

    async onSaveDaftData(po) {
      let index = this.poHasItem.findIndex((e) => e.po_id === po.po_id);
      if (po.po_id === this.newDetailEdit.po_id) {
        this.poHasItem[index] = this.newDetailEdit;
        // click button lưu, lưu data tạm, thông tin khuyến mại mới, amount mới sau khi sủa số lượng
        this.newDetailEdit.details.forEach(async (e) => {
          if (e.ids_sku === this.itemEditQuantity.ids_sku) {
            if (this.isValidQuantity) {
              const detail = {
                ...e,
                request_qty: e.request_qty,
                export_qty: e.export_qty,
                delivery_qty: e.export_qty,
                amount: e.price * e.export_qty,
                amount_org: e.price_org * e.export_qty,
                amount_basis: e.price_basis * e.export_qty,
              };
              // gọi api check promotion
              const param = {
                time_valid: this.newDetailEdit.created_at,
                po_type: this.newDetailEdit.po_type,
                sale_channel_id: this.newDetailEdit.sale_channel_id,
                customer_uid: this.newDetailEdit.customer_uid,
                trademark_uid: e.trademark_uid,
                details: [detail],
              };
              const res = await orderService.reCalculateOrder(param);
              if (res.data.error) {
                this.$notify({
                  group: "app",
                  type: "error",
                  title: "Cập nhật lỗi",
                  text: res.data.error.message,
                });
              } else {
                const newDetails = this.newDetailEdit.details.map(
                  (obj) =>
                    res.data.data.find((o) => o.ids_sku === obj.ids_sku) || obj
                );
                const body = {
                  id: this.newDetailEdit.id,
                  details: newDetails,
                };
                // console.log(body);
                const resPo = await orderService.update(body);
                if (resPo.data.error) {
                  this.$notify({
                    group: "app",
                    type: "error",
                    title: "Cập nhật lỗi",
                    text: res.data.error.message,
                  });
                } else {
                  this.poHasItem[index] = resPo.data.data;
                  this.totalQuantityItem = this.totalQuantityExport();
                  this.$notify({
                    group: "app",
                    type: "success",
                    title: "Cập nhật số lượng thành công",
                  });
                }
              }
            } else {
              this.$notify({
                group: "app",
                type: "error",
                duration: 5000,
                text: `Để không ảnh hướng đến CTKM đã áp dụng, số lượng phải lớn hơn ${
                  e.request_qty - e.max_edit_qty_allowed
                } và nhỏ hơn ${e.request_qty}`,
              });
            }
          }
        });
      } else {
        this.poHasItem[index] = po;
        this.$notify({
          group: "app",
          type: "success",
          title: "Cập nhật số lượng thành công",
        });
      }
    },

    updateSelectedPO() {
      this.selectedPrintPO = this.selectedPrintPO.map(
        (obj) => this.poHasItem.find((o) => o.po_id === obj.po_id) || obj
      );
      this.onCombineOrder();
      this.$bvModal.hide("md-edit-quantity");
    },

    getQueryString() {
      return this.$route.query;
    },

    renderSalesman(id) {
      return this.listSalesman.find((e) => e.id === id);
    },

    async onChangeStatusAndPrint() {
      this.isLoadingChangeStatusAndPrint = true;
      if (this.statusPOCombile === "CONFIRMED") {
        // nếu status của các đơn tổng hợp là CONFIRMED thì chuyển trạng thái thành EXPORTED sau đó in
        const newArr = this.selectedPrintPO.map((e) => {
          return { id: e.id, details: e.details, status: "EXPORTED" };
        });
        const res = await orderService.update({ list_po: newArr });
        if (res.data.data) {
          if (this.selectedPrintPO.length > 0) {
            let arrDetailAll = [];
            this.selectedPrintPO.forEach((e) => {
              arrDetailAll = arrDetailAll.concat(e.details);
            });
            this.distributorInfo = this.selectedPrintPO[0].distributor;
            let details = arrDetailAll.map((e) => {
              return {
                ids_sku: e.ids_sku,
                cus_sku: e.cus_sku,
                item_name: e.item_name,
                unit_id: e.unit_id,
                unit_name: e.unit_name,
                request_qty: e.request_qty,
                export_qty: e.export_qty,
                delivery_qty: e.delivery_qty,
                revoke_qty: e.revoke_qty,
                return_qty: e.return_qty,
                return_amount: e.return_amount,
                price: e.price,
                price_org: e.price_org,
                vat: e.vat,
                amount: e.amount,
                amount_org: e.amount_org,
                amount_basis: e.amount_basis,
                amount_vat: e.amount_vat ? e.amount_vat : 0,
                discount_amount: e.discount_amount,
                discount_amount_org: e.discount_amount_org,
                note: e.note,
                promotion_id: e.promotion_id,
                promotion_name: e.promotion_name,
                trademark_uid: e.trademark_uid,
              };
            });
            const res = await itemService.combineOrderByItem(details);
            if (res.data.data) {
              this.selectedPrintCombineItem = res.data.data;
              setTimeout(() => {
                this.$htmlToPaper("combineByItemPrint", null, async () => {
                  this.selectedPrintCombineItem = [];
                  this.selectedPrintPO = []
                });
                this.isLoadingChangeStatusAndPrint = false;
              }, 1000);
            } else {
              this.isLoadingChangeStatusAndPrint = false;
              this.$notify({
                group: "app",
                type: "error",
                title: "Đơn hàng có lỗi, vui lòng kiểm tra lại",
              });
            }
          } else {
            this.isLoadingChangeStatusAndPrint = false;
            this.$notify({
              group: "app",
              type: "warn",
              title: "Vui lòng chọn đơn để in",
            });
          }
        } else {
          this.isLoadingChangeStatusAndPrint = false;
          this.$notify({
            group: "app",
            type: "error",
            title: res.data.error.message,
          });
        }
        await this.getDataTable();
        this.$bvModal.hide("md-show-combine");
      } else {
        // nếu status khác thì chỉ in
        setTimeout(() => {
          this.$htmlToPaper("combineByItemPrint", null, async () => {});
          this.isLoadingChangeStatusAndPrint = false;
        }, 1000);
      }
    },

    async reloadListPO() {
      await this.getDataTable();
    },

    onChangeSaleChannel(e) {
      this.searchData.saleChannel = e;
      this.searchData.salesman = "";
    },
  },
  watch: {
    $route: {
      // lắng nghe route thay đổi param, nếu thay đổi sẽ thực thi theo logic dưới
      handler: async function (from, to) {
        this.isBusy = true;
        this.me = JSON.parse(localStorage.getItem("user"));
        if (from.fullPath === "/orders") {
          // mặc định khi vào màn hình, kiểm tra nếu là route gốc thì gọi init data + data default
          await this.getInitData();
          await this.getDataDefault();
        } else {
          // nếu có param thì filter mặc định search data theo param
          if (!to) {
            // Khi F5 lại check nếu có param thì phải init data
            await this.getInitData();
          }
          await this.checkParameter();
        }
        this.isBusy = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-12">
                <!--Search form-->
                <form>
                  <div class="row">
                    <div class="col-12" style="display: contents">
                      <div class="form-group mt-0 mb-2 mr-2 min-w-200">
                        <date-picker
                          v-model="searchData.date"
                          :first-day-of-week="1"
                          :lang="langVi"
                          range
                          format="DD/MM/YYYY"
                          placeholder="Chọn khoảng thời gian"
                          :shortcuts="shortcuts"
                        ></date-picker>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <b-input
                          @keydown.enter.native="onSearch(1)"
                          type="text"
                          class="form-control"
                          placeholder="Mã đơn"
                          v-model="searchData.id"
                          style="width: 150px"
                        />
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          :value="searchData.saleChannel"
                          :options="listSaleChannel"
                          track-by="id"
                          label="name"
                          placeholder="Đơn từ"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                          @select="onChangeSaleChannel"
                        ></multiselect>
                      </div>

                      <div
                        v-if="
                          searchData.saleChannel &&
                          searchData.saleChannel.id === 'SALESMAN'
                        "
                        class="form-group mt-0 mb-0 mr-2"
                      >
                        <multiselect
                          :max-height="150"
                          v-model="searchData.salesman"
                          :options="listSalesman"
                          track-by="id"
                          label="name"
                          placeholder="Chọn salesman"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div
                        v-if="
                          searchData.saleChannel &&
                          searchData.saleChannel.id === 'TELESALES'
                        "
                        class="form-group mt-0 mb-0 mr-2"
                      >
                        <multiselect
                          :max-height="150"
                          v-model="searchData.salesman"
                          :options="listTelesale"
                          track-by="id"
                          label="name"
                          placeholder="Chọn Telesale"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div
                        v-if="
                          searchData.saleChannel &&
                          searchData.saleChannel.id === 'DEBT_ACCOUNTANT'
                        "
                        class="form-group mt-0 mb-0 mr-2"
                      >
                        <multiselect
                          :max-height="150"
                          v-model="searchData.salesman"
                          :options="listAcctountant"
                          track-by="id"
                          label="name"
                          placeholder="Chọn kế toán"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div
                        v-if="
                          searchData.saleChannel &&
                          searchData.saleChannel.id === 'AGENCY'
                        "
                        class="form-group mt-0 mb-0 mr-2"
                      >
                        <multiselect
                          :max-height="150"
                          v-model="searchData.salesman"
                          :options="listAgency"
                          track-by="id"
                          label="name"
                          placeholder="Chọn đại lý"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <!-- <div class="form-group mt-0 mb-0 mr-2">
                        <b-input
                          @keydown.enter.native="onSearch(1)"
                          type="text"
                          class="form-control"
                          placeholder="Tên khách hàng"
                          v-model="searchData.name"
                          style="width: 150px"
                        />
                      </div> -->
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          v-model="searchData.customer"
                          :options="listCustomer"
                          track-by="id"
                          label="customer_name"
                          placeholder="Chọn khách hàng"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        >
                          <template slot="option" slot-scope="props">
                            <div>
                              <span class="option__title font-weight-bold">{{
                                props.option.customer_name
                              }}</span>
                              <br />
                              <span v-if="props.option.customer_phone"
                                >- SĐT: {{ props.option.customer_phone }}<br
                              /></span>

                              <span v-if="props.option.customer_address"
                                >- Địa chỉ:
                                {{ props.option.customer_address }}</span
                              >
                            </div>
                          </template>
                        </multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          id="shipInfo"
                          v-model="searchData.shipper"
                          :options="listShipper"
                          track-by="id"
                          label="name"
                          placeholder="Chọn giao hàng"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          v-model="searchData.status"
                          :options="listStatus"
                          track-by="id"
                          label="name"
                          placeholder="Chọn trạng thái"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          v-model="searchData.brand"
                          :options="listBrand"
                          track-by="id"
                          label="trademark_name"
                          placeholder="Chọn nhãn hàng"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="form-group mt-0 mb-0 mr-2">
                        <multiselect
                          :max-height="150"
                          v-model="searchData.customerStore"
                          :options="listCustomerStore"
                          track-by="id"
                          label="store_name"
                          placeholder="Chọn điểm đặt hàng"
                          noOptions="Danh sách trống"
                          :show-labels="false"
                          class="min-w-200"
                        ></multiselect>
                      </div>
                      <div class="mt-0">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="onSearch(1)"
                        >
                          Lọc
                        </button>
                        <button
                          type="button"
                          class="ml-2 btn btn-secondary"
                          @click="onResetSearch"
                        >
                          <i class="bx bx-revision"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                      @change="onSearch(1)"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
              <!-- Action -->
              <div class="col-sm-12 col-md-8">
                <div class="row mb-2">
                  <div class="col-lg-12">
                    <div class="d-flex justify-content-end">
                      <button
                        @click="onCombineOrder"
                        type="button"
                        class="btn btn-light mr-2"
                      >
                        <i
                          class="bx bx-package font-size-16 align-middle mr-2"
                        ></i>
                        Tổng hợp đơn
                      </button>
                      <button
                          @click="onPrint('order')"
                          type="button"
                          class="btn btn-light mr-2"
                      >
                        <i
                            :class="`bx ${isLoadingDataPrint? 'bx-loader bx-spin' : 'bx-printer'} font-size-16 align-middle mr-2`"
                        ></i>
                        In hoá đơn
                      </button>
                      <button
                        @click="onPrint('shipping')"
                        type="button"
                        class="btn btn-light mr-2"
                      >
                        <i
                          class="bx bx-printer font-size-16 align-middle mr-2"
                        ></i>
                        In phiếu GH
                      </button>
                      <button
                        @click="onPrintExport"
                        type="button"
                        class="btn btn-light mr-2"
                      >
                        <i
                          class="bx bx-printer font-size-16 align-middle mr-2"
                        ></i>
                        In phiếu XK
                      </button>
                      <button
                        @click="onExport"
                        type="button"
                        class="btn btn-light"
                      >
                        <i
                          class="bx bx-download font-size-16 align-middle mr-2"
                        ></i>
                        Export XK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End add new -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                :items="listData"
                :fields="fields"
                responsive="sm"
                :busy="isBusy"
                table-class="scroll-table"
              >
                <template v-slot:table-busy>
                  <TableLoading />
                </template>
                <template v-slot:empty>
                  <TableEmpty />
                </template>
                <template v-slot:cell(index)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template v-slot:head(checkbox)="row">
                  <b-form-checkbox
                    @change="onSelectAll($event)"
                    v-model="isSelectedAll"
                    name="selected-order"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(checkbox)="row">
                  <b-form-checkbox
                    :id="row.item.id"
                    v-model="selectedOrder"
                    @change="onSelectOrder($event)"
                    name="selected-order"
                    :key="row.item.id"
                    :value="row.item.id"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(po_id)="row">
                  <router-link
                    :to="{
                      name: 'OrderDetail',
                      params: { id: row.item.id },
                      query: getQueryString(),
                    }"
                  >
                    {{ row.item.po_id }}
                  </router-link>
                </template>
                <template v-slot:cell(region_uid)="row">
                  {{ renderRegion(row.item.region_uid) }}
                </template>
                <template v-slot:cell(customer_store)="row">
                  <p class="mb-1">
                    {{
                      row.item.customer_store
                        ? row.item.customer_store.store_contact_name
                        : "--"
                    }}
                  </p>
                  <p class="mb-0">
                    Đ/c:
                    {{
                      row.item.delivery_info
                        ? row.item.delivery_info.delivery_address
                        : "-"
                    }}
                  </p>
                </template>
                <template v-slot:cell(note)="row">
                  <p class="mb-0">
                    {{ row.item.note ? row.item.note : "--" }}
                  </p>
                </template>
                <template v-slot:cell(stocker_note)="row">
                  <p class="mb-0">
                    {{ row.item.stocker_note ? row.item.stocker_note : "--" }}
                  </p>
                </template>
                <template v-slot:cell(require_time)="row">
                  {{ formatDateUnix(row.item.require_time) }}
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ formatDateUnix(row.item.created_at) }}
                </template>
                <template v-slot:cell(status)="row">
                  <span
                    class="badge badge-pill p-2 text-uppercase"
                    :class="renderStatus(row.item.status)[1]"
                  >
                    {{ renderStatus(row.item.status)[0] }}
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mt-3" v-if="!isBusy && listData.length > 0">
              <div class="col">
                <div class="d-flex align-items-center float-right">
                  <p class="mr-3 mb-0">{{ detailPaging }}</p>
                  <b-pagination
                    class="mb-0"
                    v-model="currentPage"
                    :total-rows="totalResult"
                    @change="onChangePage"
                    :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!--  Print container  -->
    <div id="poPrint" class="bg-white p-3 text-dark d-none" v-if="!isBusy">
      <PrintPO
        v-for="(po, i) of selectedPrintPO"
        :key="i"
        :data="po"
        :me="me"
      />
    </div>
    <div id="orderPrint" class="bg-white p-3 text-dark d-none" v-if="!isBusy">
      <print-order
          v-for="(po, i) of dataPrintPO"
          :key="i"
          :data="po"
          :me="me"
      />
    </div>
    <div
      id="combineByItemPrint"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy"
    >
      <PrintCombineItem
        :listItem="selectedPrintCombineItem"
        :distributor="distributorInfo"
        :me="me"
        :shipper="searchData.shipper"
      />
    </div>
    <div
      id="poPrintExport"
      class="bg-white p-3 text-dark d-none"
      v-if="!isBusy"
    >
      <PrintExportShipper
        :data="dataPrintExport"
        :distributor="distributorInfo"
        :me="me"
      />
    </div>
    <!-- Modal Combine Order -->
    <b-modal
      id="md-show-combine"
      title="Tổng hợp đơn hàng"
      size="lg"
      @hidden="reloadListPO"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table table-bordered scroll-table">
              <tr>
                <th>STT</th>
                <th>Mã</th>
                <th class="min-w-200">Tên</th>
                <th class="min-w-140">SL yêu cầu</th>
                <th class="min-w-75">SL xuất</th>
                <th class="min-w-75">SL tồn</th>
                <th>Thành tiền</th>
              </tr>
              <tr v-for="(item, key) of selectedPrintCombineItem" :key="key">
                <td>{{ key + 1 }}</td>
                <td>{{ item.ids_sku }}</td>
                <td>{{ item.item_name }}</td>
                <td>
                  <p class="mb-1">
                    {{ formatPrice(item.request_qty) }} {{ item.unit_name }}
                  </p>
                  <template v-if="item.extra_data">
                    <div v-for="(unit, index) of item.extra_data" :key="index">
                      <p
                        class="text-muted"
                        :class="index + 1 !== item.extra_data ? 'mb-0' : 'mb-1'"
                      >
                        ({{ unit.description }})
                      </p>
                    </div>
                  </template>
                </td>
                <td>
                  <p
                    v-if="statusPOCombile === 'CONFIRMED'"
                    class="mb-0 color-link d-flex align-items-baseline"
                    @click="onShowEditDetail(item)"
                  >
                    <span>{{ item.export_qty }}</span>
                    <i class="bx bx-edit"></i>
                  </p>
                  <p v-else>{{ item.export_qty }}</p>
                  <!-- <button
                    v-else
                    :id="item.ids_sku"
                    class="
                      btn
                      p-0
                      d-flex
                      align-items-center
                      font-size-12
                      text-danger
                    "
                  >
                    {{ item.export_qty }}
                  </button> -->
                  <!-- <b-tooltip
                    v-if="item.promotion_id"
                    :target="item.ids_sku"
                    triggers="hover"
                    placement="top"
                  >
                    <p class="text-left font-weight-medium mb-1">
                      Không thể sửa số lượng xuất
                    </p>
                    <p class="text-left font-weight-medium mb-1">
                      Do có đơn hàng đang áp dụng chương trình khuyến mãi:
                      {{ item.promotion_name }}
                    </p>
                    <p class="text-left font-weight-medium mb-1">
                      Xin vui lòng vào chi tiết đơn hàng để sửa số lượng xuất
                    </p>
                  </b-tooltip> -->
                </td>
                <td>
                  <span
                    :class="
                      item.inventory_qty <= 0 ? 'text-warning' : 'text-info'
                    "
                    >{{ item.inventory_qty }}</span
                  >
                </td>
                <td>
                  {{
                    item.amount_vat
                      ? formatPrice(item.amount + item.amount_vat)
                      : formatPrice(item.amount)
                  }}
                </td>
              </tr>
              <tr>
                <td colspan="6">Tổng</td>
                <td>{{formatPrice(selectedPrintCombineItemTotal)}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <footer class="modal-footer px-0 pb-0">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="isLoadingChangeStatusAndPrint"
          @click="onChangeStatusAndPrint"
        >
          <template v-if="isLoadingChangeStatusAndPrint"
            >Đang xử lý...</template
          >
          <template v-else>
            <span v-if="statusPOCombile === 'CONFIRMED'"
              >Xử lý xuất kho và in phiếu</span
            >
            <span v-else>In phiếu tổng hợp</span>
          </template>
        </button>
      </footer>
    </b-modal>
    <!-- Modal Edit Quantity Detail -->
    <b-modal
      id="md-edit-quantity"
      :title="`Chỉnh sửa SL xuất của ${
        itemEditQuantity !== '' ? itemEditQuantity.item_name : ''
      }`"
      size="lg"
      @hidden="updateSelectedPO"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-lg-12">
          <div class="table-responsive">
            <table class="table table-bordered scroll-table">
              <tr>
                <th>STT</th>
                <th>Mã PO</th>
                <th>Thông tin liên hệ</th>
                <th>ĐVT</th>
                <th class="min-w-100">SL yêu cầu</th>
                <th class="min-w-140">SL xuất</th>
              </tr>
              <tr v-for="(po, key) of poHasItem" :key="key">
                <td>{{ key + 1 }}</td>
                <td>{{ po.po_id }}</td>
                <td>
                  <p class="mb-1">
                    KH: {{ po.customer_name }} - {{ po.customer_phone }}
                  </p>
                  <p class="mb-1" v-if="renderSalesman(po.salesman_uid)">
                    Salesman: {{ renderSalesman(po.salesman_uid).name }} -
                    {{ renderSalesman(po.salesman_uid).phone }}
                  </p>
                </td>
                <td>{{ itemEditQuantity.unit_name }}</td>
                <td>
                  {{ getQuantity(po.details, "request") }}
                </td>
                <td>
                  <div
                    class="mb-0 d-flex align-items-center"
                    v-if="checkPoHasPromotion(po)"
                  >
                    <span class="mb-0">{{
                      getQuantity(po.details, "export")
                    }}</span>
                    <i
                      :id="`tooltip-promotion-${po.po_id}`"
                      class="bx bx-info-circle ml-1 text-warning"
                    ></i>
                    <b-tooltip
                      :target="`tooltip-promotion-${po.po_id}`"
                      triggers="hover"
                    >
                      Đơn hàng có khuyến mại nên không thể chỉnh sửa số lượng.
                      Nếu muốn thay đổi số lượng vui lòng vào chi tiết đơn hoặc
                      tạo lại đơn hàng khác!
                    </b-tooltip>
                  </div>
                  <template v-else>
                    <b-input-group>
                      <b-input
                        class="w75 text-center"
                        @input="onChangeQuantity($event, po)"
                        type="text"
                        :value="getQuantity(po.details, 'export')"
                      ></b-input>
                      <b-input-group-append>
                        <b-button
                          @click="onSaveDaftData(po)"
                          variant="outline-primary"
                          >Lưu</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </template>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="mb-0 font-weight-medium">Tổng số lượng xuất</p>
                </td>
                <td>
                  <p class="mb-0 text-center font-weight-medium">
                    {{ totalQuantityItem }}
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
